import React from "react";
import MatchList from "./MatchList";
import SameMovieList from "./SameMovieList";

class MatchListContainer extends React.Component {
  render() {
    return (
        this.props.displaySameMovieList ?
            <SameMovieList sameMovieList={this.props.sameMovieList} />
            : 
            <MatchList matchList={this.props.matchList} />
    )};
}

export default MatchListContainer;